const userTokenKey = 'area_token'

export function getToken() { 
  return sessionStorage.getItem(userTokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  sessionStorage.setItem(userTokenKey,token)
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  sessionStorage.setItem(userTokenKey,'')
}

export function setUser(userinfo) {
  // return Cookies.set(TokenKey, token)
  sessionStorage.setItem(JSON.stringify(areauserInfo),userinfo)
}
export function getUser(userinfo) {
  // return Cookies.set(TokenKey, token)
  return JSON.parse(sessionStorage.getItem(areauserInfo,userinfo))
}
let appEnv = 1,baseUrl = '' // 0 测试 1 线上
if(appEnv){
	//正式
	// baseUrl = 'https://fang.linyouquan.net'
  baseUrl = 'https://city.linyouquan.net'
}else{
	//测试
	baseUrl = 'https://hh.linyouquan.net'
}
export default baseUrl


// WEBPACK FOOTER //
// ./src/utils/common.js